<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-stepper-component-editor
      v-bind="$props"
      :class="evaluateClasses(classes)"
    ></dr-stepper-component-editor>
  </dr-wrapper>
  <dr-stepper-component
    v-else-if="isVisible"
    v-bind="$props"
    :class="evaluateClasses(classes)"
  ></dr-stepper-component>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
import drStepperComponent from './dr-stepper-component.vue'
import drStepperComponentEditor from './dr-stepper-component-editor.vue'
export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  components: {
    drStepperComponent,
    drStepperComponentEditor
  }
}
</script>